import { render, staticRenderFns } from "./UpdateKnowledgeUnitExceptionDialog.vue?vue&type=template&id=74e5ab76&"
import script from "./UpdateKnowledgeUnitExceptionDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateKnowledgeUnitExceptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports